import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FishingEvent } from '../shared/fishing-event.model';
import { LocalStorageService } from '../shared/local-storage.service';
import { TripValidator } from '../shared/trip-validator.model';
import { TrawlSet } from '../shared/trawl-set.model';

export interface SetSelectionDialogData {
  data: string[];
  editedDelivery: boolean;
  fishery: string;
  isTrawlDraft?: boolean;
  isHMSDraft?: boolean;
  combinedTrawlSets?: TrawlSet[];
  combinedHMSSets?: FishingEvent[];
}


/**
 * For use on delivery-detail. 
 * Dialog to select sets that will appear on the current delivery.
 */
@Component({
    selector: 'app-set-selection-dialog',
    templateUrl: './set-selection-dialog.component.html',
    styleUrls: ['./set-selection-dialog.component.css'],
    standalone: false
})
export class SetSelectionDialogComponent implements OnInit {

  options!: FishingEvent[];
  valid: { [key: string]: boolean} = {};
  selected: FishingEvent[] = [];
  trawlOptions!: TrawlSet[];
  trawlSelected: TrawlSet[] = [];

  constructor(public dialogRef: MatDialogRef<SetSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: SetSelectionDialogData) { }

    ngOnInit(): void {
      if (this.dialogData.fishery === 'Trawl') {
        // If draft use the combined trawl sets from the dialog data.
        if (this.dialogData.isTrawlDraft && this.dialogData.combinedTrawlSets) {
          this.trawlOptions = this.dialogData.combinedTrawlSets;
        } else {
          this.trawlOptions = LocalStorageService.user_trawlTrip.sets;
        }
        // Initialize the selected sets based on the provided IDs.
        this.trawlSelected = this.trawlOptions.filter(op => this.dialogData.data.includes(op.fishingEventID));
    
        // Initialize validation statuses.
        this.trawlOptions.forEach(op => this.valid[op.fishingEventID] = true);
        TripValidator.trawlErrorWarningDialogContent().forEach(err => {
          if (err.isError) {
            this.valid[err.setID] = err.errorItems.length === 0;
          }
        });
      } else {
        // If draft use the combined hms sets from the dialog data.
        if (this.dialogData.isHMSDraft && this.dialogData.combinedHMSSets) {
          this.options = this.dialogData.combinedHMSSets.filter(set => set.fishery === this.dialogData.fishery);
        } else {
          this.options = LocalStorageService.user_trip.sets;
          this.options = this.options.filter(set => set.fishery === this.dialogData.fishery);
        }
          this.selected = this.options.filter(op => this.dialogData.data.includes(op.fishingEventID));
          this.options.forEach(op => this.valid[op.fishingEventID] = true);
          TripValidator.errorWarningDialogContent().forEach(err => {
            if (err.isError) {
              this.valid[err.setID] = err.errorItems.length === 0;
            }
          });
      }
    }
    
  compareFn(f1: FishingEvent | TrawlSet, f2: FishingEvent | TrawlSet) {
    return f1.fishingEventID == f2.fishingEventID;
  }

}
